import { createFileRoute } from "@tanstack/react-router";
import { KontaktPage, kontaktHead } from "@/pages/KontaktPage";

export const Route = createFileRoute("/de/kontakt-mi-support")({
  head: () => kontaktHead("de"),
  component: () => <KontaktPage locale="de" />,
});
